import type { MenuProps } from '@mui/material';
import type { Theme, SxProps } from '@mui/material/styles';

export const APP_MENU_PROPS: Partial<MenuProps> = {
  slotProps: {
    paper: {
      sx: {
        borderRadius: 1,
        minWidth: 250,
        overflow: 'hidden',
        boxShadow: (theme: Theme) => theme.card.shadow,
      },
    },
    list: {
      sx: { py: 0 },
    },
  },
};

export const APP_MENU_ITEM_SX: SxProps<Theme> = {
  px: 2,
  py: 1.25,
  minHeight: 44,
};

export const APP_MENU_ITEM_ICON_SX: SxProps<Theme> = {
  minWidth: 32,
  color: 'text.secondary',
};
